import OutputMixin from '@/mixin/render-output.js'
export default {
    data () {
        return {
            type: 'CHP',
            
            paramsList: [
                {
                    title: '冷却水泵规格1',
                    prop: 'CHP_Type_1',
                    Brand: 'York',  // 厂商
                    Model: '0050010120',  // 型号
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '效率(%)',
                            prop: 'Eta',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },

                {
                    title: '冷却水泵规格2',
                    prop: 'CHP_Type_2',
                    Brand: 'York',  // 厂商
                    Model: '0050013785',  // 型号
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '效率(%)',
                            prop: 'Eta',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },

                {
                    title: '冷却水泵规格3',
                    prop: 'CHP_Type_3',
                    Brand: 'None',  // 厂商
                    Model: '0000000000',  // 型号
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '效率(%)',
                            prop: 'Eta',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },
            ],
        }
    },
    mixins: [OutputMixin]
}